<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="htp01">
<a id="pagexvii">
</a><h2 class="halfTitlePageTitle"><a id="pagexvii"><span class="bold"><em class="italic">Notes from the Universe</em></span></a><a id="pagexviii">
</a></h2><a id="pagexviii">
</a></div><a id="pagexviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_htp01.vue?0434071a